<div class="embed-modal">
  <div class="embed-modal-header">
    <h3>Share Video</h3>
    <button class="close-button" (click)="cancel()">
      <mat-icon> close </mat-icon>
    </button>
  </div>
  <div class="embed-modal-body">
    <!-- TODO: add youtube and others -->
    <!-- <p>Embed a video from Youtube, Vimeo, and others for High-Resolution streaming</p> -->
    <p>Share a link from Vimeo for high-resolution video streaming.</p>

    <mat-form-field appearance="outline" class="badging-form w-full">
      <mat-label>Media Type</mat-label>
      <mat-select [(ngModel)]="selectedEmbed">
        @for (mediaType of mediaTypeOptions; track mediaType.value) {
          <mat-option [value]="mediaType.value">{{ mediaType.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="badging-form w-full">
      <mat-label>Paste Video URL</mat-label>
      <input
        [formControl]="vimeoControl"
        [errorStateMatcher]="vimeoMatcher"
        matInput
        type="url"
        required
        placeholder="Paste Video URL"
      />
      <mat-error>Please enter a valid Vimeo Url</mat-error>
    </mat-form-field>
  </div>
  <div class="embed-modal-footer">
    <app-home-button variant="text" (click)="cancel()">Cancel</app-home-button>
    <app-home-button [disabled]="vimeoControl.invalid" (click)="submit()">Share Video</app-home-button>
  </div>
</div>
